
export const CHART_COLORS = {
	primary: '#4F46E5',
	success: '#059669',
	warning: '#D97706',
	info: '#0284C7',
	danger: '#E11D48',
	muted: '#94A3B8',
}

export const CATEGORICAL = [
	CHART_COLORS.primary,
	CHART_COLORS.success,
	CHART_COLORS.warning,
	CHART_COLORS.info,
	CHART_COLORS.danger,
]

const INK = '#94A3B8'
const GRID = '#E2E8F0'

export const compactNumber = (value) => {
	const num = Number(value) || 0
	const abs = Math.abs(num)
	if (abs >= 1e9) return `${(num / 1e9).toFixed(1)} mlrd`
	if (abs >= 1e6) return `${(num / 1e6).toFixed(1)} mln`
	if (abs >= 1e3) return `${(num / 1e3).toFixed(1)} ming`
	return new Intl.NumberFormat('uz-UZ', { maximumFractionDigits: 1 }).format(num)
}

export const baseChartOptions = {
	chart: {
		toolbar: { show: false },
		fontFamily: 'inherit',
		animations: { speed: 300 },
		zoom: { enabled: false },
	},
	dataLabels: { enabled: false },
	grid: {
		borderColor: GRID,
		strokeDashArray: 4,
		xaxis: { lines: { show: false } },
	},
	xaxis: {
		axisBorder: { show: false },
		axisTicks: { show: false },
		labels: { style: { colors: INK, fontSize: '11px' } },
	},
	yaxis: {
		labels: {
			style: { colors: INK, fontSize: '11px' },
			formatter: compactNumber,
		},
	},
	legend: {
		position: 'bottom',
		horizontalAlign: 'left',
		fontSize: '12px',
		labels: { colors: '#475569' },
		markers: { width: 8, height: 8, radius: 8 },
		itemMargin: { horizontal: 10 },
	},
	tooltip: { y: { formatter: (value) => compactNumber(value) } },
}
